import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { TransactionData } from '../../interfaces/transaction/transaction-data';
import { AmountCurrencyDisplayPipe } from '../../pipes/amount-currency-display.pipe';

@Injectable({
  providedIn: 'root'
})
export class TransactionRefundToTableDataMapper {

  constructor(private amountCurrencyPipe: AmountCurrencyDisplayPipe) {
  }

  public map(transactionData: TransactionData): DialogTableDataRow[] {

    /**
     * Transaction initialized/canceled = no refund data
     */
    if (transactionData.status === 'initialized' || transactionData.status === 'canceled') {
      return null;
    }

    if (transactionData?.refundLimitReached) {
      return [
        {
          titleStyleClass: 'font-bold',
          i18nTitleKey: 'MAXAMOUNT',
          title: transactionData.currency,
          titleFormatPipe: 'AMOUNTCURRENCYLABEL',
          i18nValueKey: 'REFUNDLIMITREACHED'
        }
      ];
    } else {
      if (transactionData?.refundPossible) {
        return [
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'MAXAMOUNT',
            title: transactionData.currency,
            titleFormatPipe: 'AMOUNTCURRENCYLABEL',
            value: this.amountCurrencyPipe.transform(transactionData.refundAmountMax, transactionData.currency, 100)
          },
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'REFUNDAMOUNT',
            title: transactionData.currency,
            titleFormatPipe: 'AMOUNTCURRENCYLABEL',
            valueType: 'REFUNDAMOUNT'
          }
        ];
      } else {
        return null;
      }
    }
  }
}
